import React, { useEffect, createElement } from 'react';
import { LoginForm } from './components/LoginForm';
import { SplineStage } from './components/SplineStage';
export function App() {
  useEffect(() => {
    // Load Spline viewer script
    const script = document.createElement('script');
    document.title = 'ClientCzar Website Preview';
    script.type = 'module';
    script.src = 'https://unpkg.com/@splinetool/viewer/build/spline-viewer.js';
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="flex flex-col md:flex-row w-full h-screen overflow-hidden bg-[#0c1425]" data-id="element-0">
      {/* Left half - Spline 3D viewer with interactive effects */}
      <div id="robo-half" className="relative w-full h-1/2 md:w-1/2 md:h-[108vh] bg-black z-0" data-id="element-1">
        <SplineStage data-id="element-2" />
      </div>
      {/* Right half - login form */}
      <div id="text-half" className="relative w-full h-1/2 md:w-1/2 md:h-[108vh] bg-[#0c1425] flex items-center justify-center px-6 z-10" style={{
      marginTop: '-60px'
    }} data-id="element-3">
        <LoginForm data-id="element-4" />
      </div>
    </div>;
}